<template>
  <div style="padding: 0 10px">
    <WmsTable :columns="columns" :dataSource="dataSource" :isPagination="false" :hasHeader="false">
      <div slot="action" slot-scope="{ record }">
        <a href="javascript:;" style="padding: 0 10px" @click="chooseTemplate(record)">选择模板</a>
      </div>
    </WmsTable>
    <el-dialog title="模板选择" :visible.sync="visible" width="400px" :close-on-click-modal="false">
      <el-form :rules="rules">
        <el-form-item label="模板" prop="template" label-width="60px">
          <el-select v-model="template" filterable>
            <el-option :label="item.templateName" :value="item.templateCode" v-for="item in templateList"
              :key="item.templateCode"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: right;margin-top: 40px;">
        <el-button @click="visible = false; template = ''" style="margin: 10px;">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="模板选择" :visible.sync="checkVisible" width="400px" :close-on-click-modal="false" top="5vh">
      <div class="defaultLabelConfigDetailListScrollBox">
        <Container @drop="onDrop" non-drag-area-selector=".el-form-item__content,.el-button">
          <Draggable v-for="i, index in defaultLabelConfigDetailList" :key="index">
            <div class="defaultLabelConfigDetailListItem">
              <el-form :rules="checkRules" :model="i" ref="checkForm" style="position: relative;">
                <el-button type="danger" class="dangerBtn" @click="delDefaultLabelConfigDetailListItem(index)" :disabled="defaultLabelConfigDetailList.length < 2">删除</el-button>
                <el-form-item label="模板" prop="templateCode" label-width="60px">
                  <el-select v-model="i.templateCode" filterable>
                    <el-option :label="item.templateName" :value="item.templateCode" v-for="item in templateList"
                      :key="item.templateCode"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="张数" prop="printQuantityBasis" label-width="60px">
                  <el-radio-group v-model="i.printQuantityBasis">
                    <el-radio :label="2">自动(根据商品数量)</el-radio>
                    <el-radio :label="1">手动</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="printQuantityImport" label-width="60px" v-if="i.printQuantityBasis == 1">
                  <el-input v-model="i.printQuantityImport" placeholder="请输入张数"></el-input>
                </el-form-item>
                <!-- <el-form-item label="排序" prop="sort" label-width="60px">
                  <el-input v-model="i.sort" placeholder="请输入排序值"></el-input>
                </el-form-item> -->
              </el-form>
            </div>
          </Draggable>
        </Container>
      </div>
      <div style="text-align: left;margin-top: 10px">
        <el-button type="primary" @click="addDefaultLabelConfigDetailListItem">+添加</el-button>
      </div>
      <div style="text-align: right;margin-top: 40px;">
        <el-button @click="checkVisible = false;" style="margin: 10px;">取消</el-button>
        <el-button type="primary" @click="checkSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import { columns } from "./data";
import { defaultLabelPage, printListByType, editDefaultTemplate } from "@/apis/configure"
import { Container, Draggable } from "vue-smooth-dnd";
export default {
  title: "货格码",
  name: "ConfigureGridCode",
  components: {
    WmsTable,
    Container,
    Draggable
  },
  data() {
    return {
      columns,
      dataSource: [],
      templateList: [],
      visible: false,
      record: {},
      template: '',
      rules: {
        template: [
          { required: true, message: '请选择模板', trigger: 'blur' }
        ]
      },
      checkVisible: false,
      defaultLabelConfigDetailList: [{
        printQuantityBasis: 2,
        printQuantityImport: 1,
        templateCode: undefined,
        templateName: undefined
      }],
      checkRules: {
        templateCode: [
          { required: true, message: '请选择模板', trigger: 'blur' }
        ],
        printQuantityBasis: [
          { required: true, message: '请选择张数', trigger: 'blur' }
        ],
        printQuantityImport: [
          { required: true, trigger: 'blur', validator: (rule, value, callback) => {
              if(!value && value != 0){
                callback(new Error('请输入张数'));
                return
              }
              if(!(/^[1-9]\d*$/.test(value))){
                callback(new Error('请输入正整数'));
                return
              }
              callback();
            } 
          }
        ],
        // sort: [
        //   { required: true, message: '请输入排序', trigger: 'blur' }
        // ]
      }
    };
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      defaultLabelPage({ pageNum: 1, pageSize: 100 }).then(res => {
        this.dataSource = res.data.records
      })
    },
    getTemplateList(nodeType) {
      let that = this
      return new Promise(function (resolve, reject) {
        printListByType({ type: nodeType == 3 ? '3' : nodeType == 2 ? '6' : '1' }).then(res => {
          if (res.success) {
            that.templateList = res.data
            resolve(res)
          }
        })
      })
    },
    chooseTemplate(record) {
      console.log(record.nodeType, record.nodeType != 1)
      this.getTemplateList(record.nodeType).then(res => {
        this.record = record
        this.template = record.templateCode
        if (record.nodeType != 1) {
          this.visible = true
          return
        }
        if(record.defaultLabelConfigDetailList && record.defaultLabelConfigDetailList.length){
          this.defaultLabelConfigDetailList = record.defaultLabelConfigDetailList
        }else{
          this.defaultLabelConfigDetailList = [{
            printQuantityBasis: 2,
            printQuantityImport: 1,
            templateCode: undefined,
            templateName: undefined
          }]
        }
        this.checkVisible = true
      })
    },
    submit() {
      let params = {
        id: this.record.id,
        templateCode: this.template,
        templateName: this.templateList.filter(item => item.templateCode == this.template)[0].templateName
      }
      editDefaultTemplate(params).then(res => {
        if (res.success) {
          this.$message.success('成功')
          this.visible = false
          this.getList()
        }
      })
    },
    addDefaultLabelConfigDetailListItem() {
      this.defaultLabelConfigDetailList.push({
        printQuantityBasis: 2,
        printQuantityImport: 1,
        templateCode: undefined,
        templateName: undefined
      })
    },
    delDefaultLabelConfigDetailListItem(index){
      console.log(this.defaultLabelConfigDetailList.filter((v,i) => i != index))
      this.defaultLabelConfigDetailList = this.defaultLabelConfigDetailList.filter((v,i) => i != index)
    },
    checkSubmit() {
      const validateList = this.$refs.checkForm.map(v => {
        return v.validate()
      })
      Promise.all(validateList).then(() => {
        let params = {
          id: this.record.id,
          defaultLabelConfigDetailList: this.defaultLabelConfigDetailList.map((v,index )=> {
            return {
              ...v,
              templateName: this.templateList.filter(item => item.templateCode == v.templateCode)[0].templateName,
              sort: index + 1
            }
          })
        }
        editDefaultTemplate(params).then(res => {
          if (res.success) {
            this.$message.success('成功')
            this.checkVisible = false
            this.getList()
          }
        })
      })
    },
    onDrop(dropResult) {
      const applyDrag = (arr, dragResult) => {
        const { removedIndex, addedIndex, payload } = dragResult
        console.log(removedIndex, addedIndex, payload)
        if (removedIndex === null && addedIndex === null) return arr
        const result = [...arr]
        let itemToAdd = payload
        if (removedIndex !== null) {
          itemToAdd = result.splice(removedIndex, 1)[0]
        }
        if (addedIndex !== null) {
          result.splice(addedIndex, 0, itemToAdd)
        }
        return result
      }
      this.defaultLabelConfigDetailList = applyDrag(this.defaultLabelConfigDetailList, dropResult);
    },
  },
};
</script>

<style scoped>
.defaultLabelConfigDetailListScrollBox {
  max-height: 600px;
  overflow-y: auto;
}

.defaultLabelConfigDetailListItem {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
  position: relative;
  background-color: #fff;
  cursor: move;
}

.dangerBtn {
  position: absolute;
  right: 10px;
  z-index: 999
}
</style>
<style>
.defaultLabelConfigDetailListScrollBox .el-form-item__content {
  text-align: left;
  cursor: auto;
}
</style>
